module.exports = require('./helpers/bundle-url').getBundleURL('8aiQJ') + "2automatic.fc813c8d.svg";